import React from 'react';
import { SignatureEnvelopeState } from 'components/ItemHandle/hooks/__generated__/useItemHandleFragment.graphql';
import { createIcon } from 'components/icons/createIcon';
import { solid } from '@fortawesome/fontawesome-svg-core/import.macro';
import { useFeatureFlag } from 'utils/sessionProvider';

export const ActiveSignatureIcon = createIcon(solid('signature'));
export const CompletedSignatureIcon = createIcon(solid('signature-lock'));

interface SignatureIconProps {
  status: SignatureEnvelopeState | null;
}

export const SignatureIcon = ({ status }: SignatureIconProps) => {
  const isSignaturesEnabled = useFeatureFlag('FEATURE_SIGNATURES');

  switch (isSignaturesEnabled && status) {
    case 'SIGNING':
      return <ActiveSignatureIcon color="yellow.400" />;
    case 'COMPLETED':
      return <CompletedSignatureIcon color="green.400" />;
    default:
      return null;
  }
};
